import { getAuth, onAuthStateChanged, signOut, Auth, User } from 'firebase/auth';
import { app } from '../firebase/db';

export const auth: Auth = getAuth(app);

export function onAuthStateChange(callback: (user: User | null) => void): () => void {
  return onAuthStateChanged(auth, callback);
}

export async function logout(): Promise<void> {
  await signOut(auth);
}

export function getCurrentUser(): User | null {
  return auth.currentUser;
}
